function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { JsonUtils } from './json-utils';
/**
 * The `never` type is statically incompatible with other types. If we pass some value to this function that is not
 * of the type `never`, we get the following error message at compile time:
 *
 * > Argument of type 'SomeType' is not assignable to parameter of type 'never'.
 *
 * We can therefore use these functions with if and switch statements to protect ourselves from forgetting to handle
 * some use cases. For more information, check out
 * https://2ality.com/2020/01/typescript-enums.html#protecting-against-forgetting-cases-via-exhaustiveness-checks
 */ export function throwUnsupportedValue(value, expected) {
    var str = value;
    if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === 'object') {
        str = JsonUtils.stringify(value);
    }
    throw new TypeError("Unsupported value. Received: ".concat(str, " but expected to be one of ").concat(JsonUtils.stringify(expected)));
}
export function throwUnsupportedValueEnum(value, expected, name) {
    if (!name) {
        throwUnsupportedValue(value, Object.values(expected));
    }
    throw new TypeError("Unsupported value for enum ".concat(name, ". Received: ").concat(value, " but expected to be one of ").concat(JsonUtils.stringify(expected)));
}
export function checkUnsupportedValue(_value) {} // This type will allow you to define object property paths as strings using dot-notation
 // in a type-safe manner.
 // A type that converts all optional fields to be required but allow undefined.
 // This is useful to enforce declaration of an object property when we are dynamically setting object
 // properties and want to make sure that some values are not missed
 // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type -- Util doesn't care about the type of function
 // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type -- Util doesn't care about the type of function

//# sourceMappingURL=ts.js.map